import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { RewardSchedulesAPI } from '@API/data-services/reward-schedules-service'
import { readErrorMessage } from '@Components/util/utils'
import { S2WGameUpdateRequest } from '@Generated/back-office-client/src'
import { PRIZE_SCHEDULES_QUERY_KEY } from './types'

const SAVE_FAILED_MESSAGE = 'Could not save the game.'

// Saves, refreshes the page's data, and closes; a failure keeps the sidebar open with the server's message
export const useSaveGame = (gameId: string, onSaved: () => void) => {
  const queryClient = useQueryClient()
  const [saveError, setSaveError] = useState<string | null>(null)

  const mutation = useMutation({
    mutationFn: (update: S2WGameUpdateRequest) => RewardSchedulesAPI.updateGame(gameId, update),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: PRIZE_SCHEDULES_QUERY_KEY })
      onSaved()
    },
    onError: async (error) => setSaveError(await readErrorMessage(error, SAVE_FAILED_MESSAGE)),
  })

  const save = (update: S2WGameUpdateRequest) => {
    setSaveError(null)
    mutation.mutate(update)
  }

  return { save, saveError, isSaving: mutation.isPending }
}
